import { render, staticRenderFns } from "./AccessibilityModal.vue?vue&type=template&id=95e224f6&"
import script from "./AccessibilityModal.vue?vue&type=script&lang=js&"
export * from "./AccessibilityModal.vue?vue&type=script&lang=js&"
import style0 from "./AccessibilityModal.vue?vue&type=style&index=0&id=95e224f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports